define('plugin/package/view/PackageClientInstanceItemView',['require','plugin/package/view/PackageIntemBaseView','lib/model/package/PackageDataInflator','lib/theme/ThemeSettings'],function (require) {

    var Parent = require('plugin/package/view/PackageIntemBaseView');
    var Inflator = require('lib/model/package/PackageDataInflator');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Package instance info view
     *
     * @class PackageClientInstanceItemView
     */
    return Parent.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#package_client_instance_item_view_list';
            }
            return '#package_client_instance_item_view';
        },

        serializeData: function () {
            var data = Parent.prototype.serializeData.apply(this);
            data.highlighted = this.getOption('highlighted');

            return data;
        },

        _attachInfo: function (data) {
            data = Parent.prototype._attachInfo.apply(this, arguments);

            return new Inflator().attachPackageQtyToInstance(data);
        }

    });

});
